const createLocalSeedBackupsApi = ({ localSeedBackups }) => ({
  localSeedBackups: {
    add: localSeedBackups.add,
    get: localSeedBackups.get,
    clear: localSeedBackups.clear,
    remove: localSeedBackups.remove,
    setBackupMaxAge: localSeedBackups.setBackupMaxAge,
  },
})

const localSeedBackupsApiDefinition = {
  id: 'localSeedBackupsApi',
  type: 'api',
  factory: createLocalSeedBackupsApi,
  dependencies: ['localSeedBackups'],
}

export default localSeedBackupsApiDefinition
